import { render, staticRenderFns } from "./NewOpportunity.vue?vue&type=template&id=0e856100&"
import script from "./NewOpportunity.vue?vue&type=script&lang=js&"
export * from "./NewOpportunity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports